import React, { memo, ReactNode } from 'react'
import tw, { TwStyle } from 'twin.macro'
import { Typography } from '@mui/material'
import { colors } from 'src/theme'

interface TableLabelProps {
  label: string
  className?: TwStyle
  beforeIcon?: ReactNode
  textColor?: string
}

const TableLabelComponent = ({
  label,
  className,
  beforeIcon,
  textColor = colors.SHADES_GREY_600,
}: TableLabelProps) => {
  if (!label) {
    return null
  }

  return (
    <div css={[tw`bg-[#EDEDED] rounded-[10px] flex items-center px-3 py-1 h-5`, className]}>
      {beforeIcon && <span css={tw`mr-1 flex items-center`}>{beforeIcon}</span>}
      <Typography variant="subtitle2" noWrap color={textColor}>
        {label}
      </Typography>
    </div>
  )
}

export const TableLabel = memo(TableLabelComponent)
